<template>
  <div class="container">
    <div class="card-title">
      <h1>Get in touch</h1>
    </div>
    <div class="card">
      <div class="card-image">
        <img
          src="@/assets/Riaan.webp"
          alt="Image of Riaan Heugh , owner of RHDesigns"
        />
      </div>
      <div class="card-content">
        <div class="card-info">
          <div class="email">
            <i class="fa fa-envelope">-</i>
            <h4>riaanheugh@gmail.com</h4>
          </div>
          <div class="cell">
            <i class="fa fa-whatsapp">-</i>
            <h4>0823448884 - whatsapp</h4>
          </div>
          <hr width="35%" />
        </div>
        <p class="services">
          Sublimation Printing, Vinyl Printing, Apparel Fulfillment. Based in
          Cape Town, Western Cape, South Africa.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.container {
  font-family: "Kanit", sans-serif;
  text-align: center;
  max-width: 1300px;
  margin: 2rem auto;
  padding: 0 1rem;
  transition: all 0.25s ease-in-out;
}
.card-title {
  text-transform: uppercase;
}

.card {
  max-width: 600px;
  border-radius: 15px;
  margin: 1rem auto;
  padding: 1.5rem 0.5rem;
  background-color: #ff660094;
  display: flex;
  gap: 5px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 3px 3px 5px 3px rgba(0, 0, 0, 0.25);
  overflow: hidden;
}
.card-info {
  display: flex;
  gap: 2px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.email,
.cell {
  min-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  font-size: 1.2rem;
}
.services {
  margin-top: 0.5rem;
}
.card-title {
  font-family: boombox, Helvetica, Arial, sans-serif;
}
.card-image {
  max-width: 100%;
  height: 100%;
  overflow: auto;
}
.card-image img {
  width: 45%;
  height: 100%;
  object-fit: cover;
  object-position: center;
}

/*=========================================== MEDIA=========================================================== */
@media screen and (min-width: 500px) {
  .card {
    flex-direction: row;
    gap: 0;
  }
  .card-image img {
    width: 75%;
  }
}
@media screen and (min-width: 768px) {
}
</style>